import { Box, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import RFIIcon from '../../../../assets/svg/dashboardRFIIcon.svg';

interface RequestForInformation {
  value: number;
}
const RequestForInformationCount = ({ value }: RequestForInformation) => {
  const navigate = useNavigate();
  return (
    <Stack padding='20px'>
      <Stack
        direction='row'
        alignItems='center'
        spacing={1}
        paddingBottom='10px'
      >
        <Box component='img' src={RFIIcon} width={24} height={24} />
        <Typography
          sx={{
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '125%',
            paddingTop: '5px',
          }}
        >
          <FormattedMessage defaultMessage='Request for Information' />
        </Typography>
      </Stack>
      <Typography
        sx={{
          fontSize: '28px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '125%',
        }}
      >
        {value}
      </Typography>
      <Box display='flex' justifyContent='space-between'>
        <Typography
          sx={{
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '125%',
            color: '#878787',
          }}
        >
          <FormattedMessage defaultMessage='Total RFI' />
        </Typography>

        <Typography
          sx={{
            color: '#00CECF',
            fontFamily: 'Schibsted Grotesk',
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '125%',
            textTransform: 'none',
            cursor: 'pointer',
          }}
          onClick={() => navigate('request-for-information')}
        >
          <FormattedMessage defaultMessage='View' />
        </Typography>
      </Box>
    </Stack>
  );
};

export default RequestForInformationCount;
